export default {
  methods: {
    redirect: function ({ notification }) {
      if (notification.context.redirect === this.$route.fullPath)
        window.location.reload()
      else this.$router.push(notification.context.redirect)
    },
  },
}
